import { useEffect } from "react";
import ProfileLayout from "../../layouts/Profile.layout";
import { Label, ListControl, Till } from "../../components/common";
import { securityList } from "../../utils/prepareData/security";
import { selectCurrentUser } from "../../store/reducers/user";
import { useSelector } from "react-redux";
import { useDisableTfaMutation } from "../../store/services/tfa";
import { toastSuccess } from "../../utils/toasts";
import { useTriggerToastOnRTKError } from "../../hooks/useTriggerToastOnRTKError";
import { settingsList } from "../../utils/prepareData/settings";

export const SettingsSecurity = () => {
  const user = useSelector(selectCurrentUser);
  const [disableTfa, { isSuccess, isError, error }] = useDisableTfaMutation();

  useTriggerToastOnRTKError(isError, error);

  const { email, phone } = user;
  const securityData = securityList(user, disableTfa);
  const contactData = settingsList({ email, phone });

  useEffect(() => {
    if (isSuccess) {
      toastSuccess("Two-factor verification disabled");
    }
  }, [isSuccess]);

  return (
    <ProfileLayout>
      <h1 className="hidden md:block theme-heading text-center mb-8">
        Security
      </h1>

      <div className="hidden md:block theme-subheading text-center mb-16">
        Protect your account
      </div>

      <div className="md:hidden w-full flex flex-col items-stretch">
        {contactData.map((contact) => (
          <ListControl
            key={contact.label}
            className="border-b last:border-b-0 border-gray-50 py-6"
          >
            <div className="">
              <div className="flex flex-row justify-evenly gap-x-2 md:gap-x-6 w-full">
                <Till icon={contact.icon} />

                {contact.value ? (
                  <Label label={contact.label} valueClassName="break-all">
                    {contact.value}
                  </Label>
                ) : (
                  <div className="items-center flex text-base">
                    {contact.label}
                  </div>
                )}

                {contact.action}
              </div>
            </div>
            {contact.hint && (
              <div className="pt-4 theme-text-secondary text-sm">
                {contact.hint}
              </div>
            )}
          </ListControl>
        ))}
      </div>

      <div className="w-full flex flex-col items-stretch">
        {securityData.map((contact) => (
          <ListControl key={contact.value}>
            <div className="border-b last:border-b-0 border-gray-50 py-6 w-full flex flex-row gap-x-6">
              <Till icon={contact.icon} />
              <div className="items-center flex text-base">{contact.value}</div>
              {contact.action}
            </div>
          </ListControl>
        ))}
      </div>
    </ProfileLayout>
  );
};
